export const T = {
  background: '#FDF9F3',
  surface: '#F5ECE2',
  text: '#1A1815',
  textSecondary: '#8A827A',
  primary: '#FF914D',
  primaryLight: '#FFA870',
  border: 'rgba(221,193,181,0.30)',
} as const;

export const APP_STORE_URL = 'https://apps.apple.com/us/app/id6762112915';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.oasis.app';
export const ANDROID_PACKAGE = 'com.oasis.app';
